// extracted by mini-css-extract-plugin
module.exports = {"buttons":"aea-file-modal_buttons__15I-X"};